import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";
import ScrollReveal from "@/components/ScrollReveal";
import { Mic } from "lucide-react";

const TalentCTA = () => {
  const { t } = useTranslation();
  const { localizedPath } = useLocalizedPath();

  return (
    <section className="section-padding bg-muted/50 border-t border-border">
      <div className="container-wide">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Mic className="w-6 h-6 text-primary" />
            </div>
            <div>
              <ScrollReveal>
                <h3 className="font-display text-lg sm:text-xl font-medium mb-1 text-primary">
                  {t("talentCTA.title")}
                </h3>
              </ScrollReveal>
              <ScrollReveal delay={0.1}>
                <p className="text-muted-foreground text-sm sm:text-base">
                  {t("talentCTA.subtitle")}
                </p>
              </ScrollReveal>
            </div>
          </div>
          <ScrollReveal delay={0.2}>
            <Button asChild variant="sectionCta">
              <Link to={localizedPath("/for-talent")}>
                {t("talentCTA.button")}
              </Link>
            </Button>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default TalentCTA;
